// Shared variant/size scales for Button, TextButton, and IconButton — the Ultralight DS
// "Button" family (design_handoff_buttons/). Button and IconButton use the same 5-variant
// filled/bordered scale; all three share the same 6-step size scale.

export const BUTTON_SIZE = {
  Size20: "20",
  Size24: "24",
  Size28: "28",
  Size32: "32",
  Size36: "36",
  Size40: "40",
} as const;

export type ButtonSize = (typeof BUTTON_SIZE)[keyof typeof BUTTON_SIZE];

export const BUTTON_FILLED_VARIANT = {
  Primary: "primary",
  Secondary: "secondary",
  Tertiary: "tertiary",
  Ghost: "ghost",
  Destructive: "destructive",
  // Patient-web CTA: the patient portal's secondary-blue fill (`PatientPrimaryButton`), not yellow.
  PatientPrimary: "patient-primary",
} as const;

export type ButtonFilledVariant =
  (typeof BUTTON_FILLED_VARIANT)[keyof typeof BUTTON_FILLED_VARIANT];
